import ReactApexChart from "react-apexcharts";

const useReactApexChart = () => {
  const createChartTwo = (color, height, categories = [], data = []) => {
    const options = {
      chart: {
        type: "line",
        height,
        toolbar: { show: false },
        zoom: { enabled: false },
      },
      stroke: {
        curve: "smooth",
        width: 3,
      },
      colors: [color],
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories,
      },
      yaxis: {
        labels: {
          formatter: (val) => `₹${val}`,
        },
      },
      grid: {
        strokeDashArray: 4,
      },
    };

    const series = [
      {
        name: "Sales",
        data,
      },
    ];

    return (
      <ReactApexChart
        options={options}
        series={series}
        type="line"
        height={height}
      />
    );
  };

  return { createChartTwo };
};

export default useReactApexChart;
